import React from 'react'
import { cn } from '@utils/safeTs'
import { Modal, WImage } from '@components/atoms'
import styles from './ZoomModal.module.sass'


interface Props {
  id: string
  url: string
  open: boolean
  onClose: () => void
  children?: React.ReactNode
  className?: string
}

const ZoomModal = (props: Props) => {

  const { 
    id,
    url,
    open = false,
    onClose,
    children,
    className = '',
  } = props

  return !!url && (
    <Modal
      id={id}
      open={open}
      onClose={onClose}
      mainClassName={styles.main}
      bodyClassName={styles.body}
      closeClassName={styles.close}
      className={cn(styles.root, className)}
    >
      <WImage
        src={url}
        maxWidth={1920}
        maxHeight={1920}
        objectFit='contain'
      />
    </Modal>
  )
}

export default ZoomModal
